import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=47aa1ab8&scoped=true&"
import script from "./InfoIcon.vue?vue&type=script&lang=js&"
export * from "./InfoIcon.vue?vue&type=script&lang=js&"
import style0 from "./InfoIcon.vue?vue&type=style&index=0&id=47aa1ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aa1ab8",
  null
  
)

export default component.exports